import { multiOffersService } from '../../infrastructure/Factory'

export default {
  allLocations(state) {
    return state.allDestinations.reduce(function(accumulator, curValue) {
      return accumulator.concat([
        { ...curValue, type: 'country' },
        ...curValue.cities.map(city => ({ ...city, type: 'city' }))
      ])
    }, [])
  },
  allDestinations(state) {
    return state.allDestinations
  },
  selectedCode(state) {
    return state.filterApply.code
  },
  hotDestinations(state) {
    const citiesSortAlphabetically = state.offer.cities.sort((a, b) =>
      a.title.localeCompare(b.title)
    )

    return multiOffersService.getHotDestinations(citiesSortAlphabetically, state.allDestinations)
  },
  filteredDestinations(state, getters) {
    return getters.allLocations.filter(item => item.code === state.filterApply.code)
  },
  offer(state) {
    return state.offer
  },
  allHotels(state) {
    return state.hotels
  },
  allPrices(state) {
    const priceArray = state.prices.map(item => item.hotels)

    return priceArray.reduce((acc, val) => acc.concat(val), [])
  },
  applyFilters(state) {
    return state.filterApply
  },
  getFormattedLocations: state => state.formattedLocation,

  moreDestinationsBanners: state => state.moreDestinationsBanners,

  modalSmartLinkImages: state => state.modalSmartLinkImages
}
